import { useTranslation } from 'react-i18next';
import { useUiSound } from '../hooks/useUiSound';
import { SoundOffIcon, SoundOnIcon } from './Icons';


export function SoundToggle({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const { enabled, toggle } = useUiSound();
  const label = enabled ? t('sound.on') : t('sound.off');
  const Icon = enabled ? SoundOnIcon : SoundOffIcon;

  if (compact) {
    return (
      <button
        type="button"
        className="icon-button sound-toggle"
        aria-pressed={enabled}
        aria-label={label}
        title={label}
        onClick={toggle}
      >
        <Icon size={18} />
      </button>
    );
  }

  return (
    <div className="segmented sound-toggle" role="group" aria-label={t('sound.group')}>
      <button type="button" role="switch" aria-checked={enabled} onClick={toggle}>
        <Icon size={18} />
        <span>{enabled ? t('sound.enabled') : t('sound.muted')}</span>
      </button>
    </div>
  );
}
